import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import productReducer from './slices/product';
import elementReducer from './slices/element';
import promoReducer from './slices/promo';
import magictypeReducer from './slices/magictype';
import tagReducer from './slices/tag';
import cardReducer from './slices/card';
import rarityReducer from './slices/rarity';
import spellReducer from './slices/spell';
import studentReducer from './slices/student';
import characterReducer from './slices/character';
import appointReducer from './slices/appoint';
import todayShadowReducer from './slices/todayShadow';
import slotReducer from './slices/slot';
import singleslotReducer from './slices/singleslot';
import allslotReducer from './slices/allslots';
import notificationReducer from './slices/notification';
import creviewReducer from './slices/creview';
import cProviderReducer from './slices/clinicProvider';
import companyClinicReducer from './slices/companyClinic';
import clinicsAppointmentReducer from './slices/clinicAppointment';
import DressCode from './slices/DressCode';
import RegistrationForm from './slices/RegistrationForm';
import CheckInfo from './slices/CheckInfo';
import checkerpaymentReducer from './slices/checkerpayment';
import dashboardReducer from './slices/dashboard';
import shownotificationclinicReducer from './slices/shownotificationclinic';
import reviewsReducer from './slices/reviews';

const rootPersistConfig = {
  key: 'root',
  storage,
  // keyPrefix: 'redux-',
  // whitelist: [],
};

const rootReducer = combineReducers({
  element: elementReducer,
  promo: promoReducer,
  magictype: magictypeReducer,
  tag: tagReducer,
  card: cardReducer,
  rarity: rarityReducer,
  spell: spellReducer,
  student: studentReducer,
  character: characterReducer,
  product: productReducer,
  appoint: appointReducer,
  todayShadow: todayShadowReducer,
  slot: slotReducer,
  singleslot: singleslotReducer,
  allslots: allslotReducer,
  creview: creviewReducer,
  cProvider: cProviderReducer,
  companyClinic: companyClinicReducer,
  clinicsAppointment: clinicsAppointmentReducer,
  dresscode: DressCode,
  registrationForm: RegistrationForm,
  checkInfo: CheckInfo,
  notification: notificationReducer,
  checkerpayment: checkerpaymentReducer,
  dashboard: dashboardReducer,
  shownotificationclinic: shownotificationclinicReducer,
  reviews: reviewsReducer,
});

export { rootPersistConfig, rootReducer };
